/** @format */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxFudisModule } from '@funidata/ngx-fudis';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslateModule } from '@ngx-translate/core';
import { SisCommonModule } from 'sis-common';
import { SisComponentsModule } from 'sis-components';
import { CourseCartComponent } from './course-cart.component';

@NgModule({
    declarations: [CourseCartComponent],
    imports: [CommonModule, TranslocoModule, TranslateModule.forChild(), SisCommonModule, SisComponentsModule, NgxFudisModule],
})
export class CourseCartModule {}
